<div ngClass="container">
  <div class="container-image">
    <img src="{{ tableNotFoundIcon }}" />
  </div>
  <div class="container-text">{{ tableNotFoundText }}</div>
</div>
